<template>
  <b-modal size="md" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <b-container>
      <b-row>
        <b-col>

          <LgFinderPageBanco class='col-12' v-model="form.banco" :value="form.banco" label="Banco:*" id="finderBanco"
            invalidFeedback="Banco deve ser informado!" description="" :prefix="updatedPrefix" />


          <b-form @submit.prevent="submitForm">
            <lg-form-input v-model="form.agencia" label="Agência: *" required></lg-form-input>

            <lg-form-input v-model="form.numero" label="Número da Conta: *" required></lg-form-input>

            <b-form-group label-for="principal" class="col-12">
              <b-form-checkbox id="principal" v-model="form.principal">Principal</b-form-checkbox>
            </b-form-group>


            <b-form-radio-group size="sm" v-model="form.situacao" :options="optionsSituacao" name="situacao-options"
              class="d-flex col-12">
            </b-form-radio-group>
            <div class="d-flex justify-content-center mt-3">
              <b-button id="adicionarBancoCadastro" type="submit" variant="success" style="height: 30px" pill size="sm">
                <div class="btn-size-alinhamento">
                  <b-icon icon="check-circle" />
                  <b-tooltip target="adicionarBancoCadastro" title="Salvar"></b-tooltip>

                </div>
              </b-button>
              <b-button id="cancelarBancoCadastro" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                variant="danger">
                <div class="btn-size-alinhamento">
                  <b-icon icon="x-circle" />
                  <b-tooltip target="cancelarBancoCadastro" title="Cancelar"></b-tooltip>

                </div>
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>

import LgFinderPageBanco from "@/components/Finders/LgFinderPageBanco.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin } from "@/core/mixins/resource"

export default {
  components: {
    LgFormInput,
    LgFinderPageBanco,
  },
  data() {
    return {
      showModal: true,
      optionsBanco: [],
      optionsSituacao: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],
      form: {
        agencia: "",
        numero: "",
        banco: {},
        principal: true,
        situacao: 1,
        codEmpresa: this.codEmpresa,
      },
    };
  },
  mixins: [ConfirmMixin, FormResourceMixin],
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
    codEmpresa: {
      type: Number,
      required: true,
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/contabancaria`);
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
      this.form.codEmpresa = this.codEmpresa;
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    async submitForm() {

      if (!this.form.banco || !this.form.banco.id) {

        this.notify({
          title: "Erro",
          message: "Selecione um banco",
          type: "danger",
        });
      }


      this.$service.save(this.form).then(() => {
        this.$notify({
          type: "success",
          message: "Registro salvo com sucesso",
        });

        this.cancelar();

      }).catch(() => {
        this.$notify({
          type: "danger",
          message: "Este registro já está cadastrado",
        });

      });



    },
    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>

<style scoped>
.btn-size-alinhamento {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
